import { useTranslation } from "react-i18next";

const TextsWrapper = () => {
  const { t } = useTranslation("register");
  return (
    <div className="flex-1 flex-col gap-10 p-6 tracking-wider text-white hidden lg:flex mt-[20vh]">
      <span className="text-2xl xl:text-3xl font-semibold">
        {t("sub_title")}
      </span>

      <span className="md:text-4xl xl:text-6xl font-semibold !leading-snug [text-wrap:pretty] max-w-4xl">
        {t("title")}
      </span>

      <span className="text-lg xl:text-xl font-medium !leading-snug [text-wrap:pretty] max-w-4xl">
        {t("info_text")}
      </span>
    </div>
  );
};

export default TextsWrapper;
